import {Box, Typography} from '@mui/material';

import {
  AppButton,
  AppButtonVariant,
  ButtonContainer,
} from '@/app/shared-components';
import ChangeTextWithColorAndImage from '@/app/shared-components/ColorAndImageText/ColorAndImageText';
import ResultScreen from '@/app/shared-components/ResultScreen/ResultScreen';
import {COLORS} from '@/styles/colors';

import {useViewModelProvider, ViewModelProvider} from './ViewModelContext';

const AddKidWarningContent: React.FC = () => {
  const {kidData, handleTryAgain, handleContactCS} = useViewModelProvider();

  return (
    <Box sx={{display: 'flex', alignSelf: 'center', maxWidth: '600px'}}>
      <ResultScreen
        imgSrc="/assets/images/etc/warning.webp"
        title={
          <Box className="content">
            <ChangeTextWithColorAndImage
              text={`<${COLORS.ELECTRIC_VIOLET};${kidData.firstName}'s> account creation is taking longer than expected.`}
              textStyle={{
                color: COLORS.ON_SURFACE,
                fontFamily: 'Poppins',
                fontSize: 22,
                fontStyle: 'normal',
                fontWeight: 600,
                letterSpacing: -0.22,
              }}
            />
          </Box>
        }
        description={
          <Box className="content">
            <Typography
              sx={{
                color: COLORS.ON_SURFACE_VARIANT,
                fontFamily: 'Poppins',
                fontSize: 16,
                fontStyle: 'normal',
                fontWeight: 400,
                letterSpacing: 0.15,
              }}>
              Please try again. If the situation persists, contact our Customer
              Service.
            </Typography>
          </Box>
        }
        bottomContent={
          <ButtonContainer sticky>
            <AppButton
              label="Try again"
              onClick={handleTryAgain}
              variant={AppButtonVariant.onPrimary}
            />

            <AppButton
              label="Contact Customer Support"
              onClick={handleContactCS}
              variant={AppButtonVariant.onSecondary}
            />
          </ButtonContainer>
        }
      />
    </Box>
  );
};

const AddKidWarningPage = () => {
  return (
    <ViewModelProvider>
      <AddKidWarningContent />
    </ViewModelProvider>
  );
};

export default AddKidWarningPage;
